import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-edit-overview-action-types';

import type {Map} from 'immutable';

export type ReservationEditOverviewStore = {
    reservation: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        reservation: Immutable.Map(),
    };
};

const actionsMap = {
    [actionTypes.GET_RESERVATION_SUCCESS]: (state, action) => {
        return {
            reservation: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationEditOverviewStore>(initialState(), actionsMap);
